import BaseButton from '../../../shared/BaseButton/BaseButton';
import captureError from '../../../utils/captureError';
import FormErrorMessages from '../../../shared/Forms/Messages/FormErrorMessages';
import FormSuccessMessages from '../../../shared/Forms/Messages/FormSuccessMessages';
import { translate } from '../../../App/Internationalization';
import React from 'react';

/**
 * @typedef {{
 * 	buttonLabel: string,
 * 	canRequestValuation: boolean,
 * 	description: string,
 * 	onRequestValuation: () => Promise<void>
 * }} Props
 */

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
function ComparableMarketValuationRequest(props) {
	const [isRequestingAccurateValuation, setIsRequestingAccurateValuation] =
		React.useState(false);
	const [requestStatus, setRequestStatus] = React.useState(
		/** @type {'error' | 'success' | null} */ (null)
	);

	async function handleRequestValuationReport() {
		setIsRequestingAccurateValuation(true);
		setRequestStatus(null);

		try {
			await props.onRequestValuation();
			setRequestStatus('success');
		} catch (error) {
			captureError(error);
			setRequestStatus('error');
		} finally {
			setIsRequestingAccurateValuation(false);
		}
	}

	let requestStatusMessage = null;
	if (requestStatus === 'success') {
		requestStatusMessage = (
			<FormSuccessMessages
				className="w-full"
				messages={[
					translate(
						'homeowner.pages.finances.view.estimate.request.success'
					),
				]}
			/>
		);
	} else if (requestStatus === 'error') {
		requestStatusMessage = (
			<FormErrorMessages
				className="w-full"
				messages={[
					translate(
						'homeowner.pages.finances.view.estimate.request.error'
					),
				]}
			/>
		);
	}

	return (
		<div
			style={{
				alignItems: 'flex-start',
				display: 'flex',
				flexDirection: 'column',
				gap: '0.75rem',
				marginTop: '1.5rem',
				minHeight: '3.5rem',
				position: 'relative',
				width: '100%',
				zIndex: 5,
			}}
		>
			<div
				className="-text-ms-2"
				style={{
					lineHeight: '1.3',
					textAlign: 'left',
					whiteSpace: 'normal',
					width: '100%',
				}}
			>
				{props.description}
			</div>

			<div
				style={{
					alignSelf: 'flex-start',
					width: '100%',
				}}
			>
				<BaseButton
					className="w-full sm:w-auto"
					disabled={
						!props.canRequestValuation ||
						isRequestingAccurateValuation
					}
					onClick={handleRequestValuationReport}
					outline={true}
				>
					{isRequestingAccurateValuation
						? translate(
								'homeowner.pages.finances.view.estimate.request.submitting'
						  )
						: props.buttonLabel}
				</BaseButton>
			</div>

			{requestStatusMessage}
		</div>
	);
}

export default ComparableMarketValuationRequest;
